module.exports = __webpack_public_path__ + "static/media/hamamo_only_logo_delivery.3f3d1631.png";